var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.bM=require("moment");module.exports=$CLJS.bM;